import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@reach/router';

const ListItem = ({ href, name, ...rest }) => (
  <li className="bb b--light-gray pv2 mv1 truncate" {...rest}>
    <Link to={href} className="navy serif f3 fw5 hover-blue">
      {name}
    </Link>
  </li>
);

ListItem.propTypes = {
  href: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
};

export default ListItem;
